import { configureStore } from '@reduxjs/toolkit'
import type { EnhancedStore } from '@reduxjs/toolkit'

import { baseApi } from './api'
import { setProductSourceMiddleware } from './middlewares/setProductSourceMiddleware'
import { setUserMiddleware } from './middlewares/setUserMiddleware'
import authReducer from './slices/authSlice'
import dataManagementReducer from './slices/dataManagementSlice'
import layoutReducer from './slices/layoutSlice'
import settingsReducer from './slices/settingsSlice'
import socketReducer from './slices/socketSlice'

const createStore = (): EnhancedStore =>
  configureStore({
    reducer: {
      [baseApi.reducerPath]: baseApi.reducer,
      settings: settingsReducer,
      auth: authReducer,
      layout: layoutReducer,
      dataManagement: dataManagementReducer,
      socket: socketReducer,
    },
    devTools: CURRENT_ENV !== 'prod',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat(
        baseApi.middleware,
        setUserMiddleware(baseApi),
        setProductSourceMiddleware(baseApi),
      ),
  })

export const store = createStore()

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
